module.exports = __webpack_public_path__ + "851f4c90f79bd3547cd4bf24b122c367.png";